import React from 'react';
import { WifiSlash, Gauge } from '@phosphor-icons/react';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

const NetworkStatus: React.FC = () => {
  const { isOnline, isSlowConnection } = useNetworkStatus();

  if (isOnline && !isSlowConnection) return null;

  if (!isOnline) {
    return (
      <div className="network-status network-status-offline" role="status" aria-live="polite">
        <WifiSlash size={18} weight="fill" aria-hidden />
        <span>Hors ligne</span>
      </div>
    );
  }

  return (
    <div className="network-status network-status-slow" role="status" aria-live="polite">
      <Gauge size={18} weight="fill" aria-hidden />
      <span>Connexion lente</span>
    </div>
  );
};

export default NetworkStatus;
